import {map as m,propEq,compose as C, filter as f,prop as p, 
    groupBy as g,juxt,omit,reduce,values,mean,curry} from "ramda";

export const r = curry((pow,x) => 
    Math.round(x*Math.pow(10,pow))/Math.pow(10,pow));

export const mean_of = x => C(
    mean,
    m(p("value_number")),
    f(C(propEq("type", x),p("activities_with_types")))
)

export const weighted = C(
    r(3),
    reduce((a,b) => a+b,0),
    f(x => !Number.isNaN(x)),
    values,
    m(C(
      ([weight,score]) => weight/100*score,
      juxt([mean_of("weighting"),mean_of("voting")])
    )),
    omit([null]),
    g(p("input_id"))
)